/**
 * Resolve a user-visible message from an axios upload error response.
 * @param {import('axios').AxiosError} err
 * @param {function(string): string} t - vue-i18n $t
 * @returns {string}
 */
export function uploadErrorMessage(err, t) {
  const raw = err?.response?.data?.message;
  if (!raw) {
    return t("error_occurred");
  }
  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object") {
      for (const key of Object.keys(parsed)) {
        const val = parsed[key];
        const text = Array.isArray(val) ? val[0] : val;
        if (text) {
          return String(text);
        }
      }
    }
  } catch (e) {
    // plain string message (e.g. logo_updated keys or single-line errors)
  }
  const translated = t(raw);
  return translated !== raw ? translated : raw;
}
